/* eslint-disable no-use-before-define */
import { AppThunk } from '../../../store/reducers';
import { DELETE, GET, PATCH, POST, PUT } from '../../../service/HttpMethod';
import {
	InitialState,
	ActionConstant,
	ActionType,
	Lists,
	EnterpriseLists,
	ProdOwnerOrgDetailsList,
	NormalLists,
	Org,
	Orgsummary,
} from './types';
import { toastFunction } from '../../../helpers/toastShow';

const initialState: InitialState = {
	count: 0,
	list: [],
	listFetching: true,
	statusCode: 0,
	orgdetails: { name: '', id: 0, primaryContact: '', location: '', phone: '', email: '' },
	orgdetailsFetching: true,
	orgsummarydetails: {
		organizationsTotal: 0,
		paidOrganizations: 0,
		trailPlanOrganizations: 0,
		expired: 0,
		totalIndexSubscribed: 0,
		totalIndexUsed: 0,
	},
	orgsummarydetailsFetching: true,
	enterpriselist: [],
	enterpriselistFetching: true,
	prodOwnerOrgDetails: [],
	prodOwnerOrgDetailsFetching: true,
	normallist: [],
	normallistFetching: true,
};

const GetDetailsAction = (data: Lists): ActionType => ({
	type: ActionConstant.GET_DETAILS,
	data,
});
const GetNormalDetailsAction = (data: NormalLists): ActionType => ({
	type: ActionConstant.GET_NORMAL_DETAILS,
	data,
});
const GetEnterpriseDetailsAction = (data: EnterpriseLists): ActionType => ({
	type: ActionConstant.GET_ENTERPRISE_DETAILS,
	data,
});
const GetProdOwnerOrgDetails = (data: ProdOwnerOrgDetailsList): ActionType => ({
	type: ActionConstant.GET_PROD_OWNER_ORG_DETAILS,
	data,
});

const ClearProdOwnerOrgDetails = (): ActionType => ({
	type: ActionConstant.CLEAR_PROD_OWNER_ORG_DETAILS,
});

const GetOrgDetailsAction = (data: Org): ActionType => ({
	type: ActionConstant.GET_ORG_DETAILS,
	data,
});
const GetOrgSummaryDetailsAction = (data: Orgsummary): ActionType => ({
	type: ActionConstant.GET_ORG_SUMMARY_DETAILS,
	data,
});
export const clearDetails = (): ActionType => ({ type: ActionConstant.CLEAR_DETAILS });

export const clearNormalDetails = (): ActionType => ({ type: ActionConstant.CLEAR_NORMAL_DETAILS });

export const clearEnterpriseDetails = (): ActionType => ({
	type: ActionConstant.CLEAR_ENTERPRISE_DETAILS,
});

export const clearOrgDetails = (): ActionType => ({ type: ActionConstant.CLEAR_ORG_DETAILS });

export const clearOrgSummaryDetails = (): ActionType => ({
	type: ActionConstant.CLEAR_ORG_SUMMARY_DETAILS,
});

export const clearStatus = (): ActionType => ({ type: ActionConstant.CLEAR_STATUS });

export const getDetails = (): AppThunk => {
	// project details
	const getConfig = { url: `organizations` };
	return async (dispatch) => {
		try {
			dispatch(getOrgSummaryDetails());
			dispatch(clearDetails());
			const { data = {} } = await GET(getConfig);
			dispatch(GetDetailsAction(data));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
};
export const getNormalDetails = (): AppThunk => {
	// project details
	const getConfig = { url: `organizationsSubsciptions` };
	return async (dispatch) => {
		try {
			dispatch(getOrgSummaryDetails());
			const { data = {} } = await GET(getConfig);
			dispatch(GetNormalDetailsAction(data));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
};
export const getEnterpriseDetails = (): AppThunk => {
	// project details
	const getConfig = { url: `enterpriseSubscriptions` };
	return async (dispatch) => {
		try {
			dispatch(getOrgSummaryDetails());
			const { data = {} } = await GET(getConfig);
			dispatch(GetEnterpriseDetailsAction(data));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
};

export function updateEnterpriseBillingEligibility(
	organizationId: number,
	enabled: boolean,
): AppThunk<Promise<boolean>> {
	return async (dispatch) => {
		try {
			await PATCH({
				url: `organizations/${organizationId}/enterprise-billing-eligibility`,
				data: { enabled },
			});
			dispatch(clearDetails());
			dispatch(clearEnterpriseDetails());
			dispatch(getDetails());
			dispatch(getEnterpriseDetails());
			dispatch(
				toastFunction(
					'Success',
					`Enterprise billing ${enabled ? 'enabled' : 'disabled'} successfully`,
					'',
				),
			);
			return true;
		} catch (error) {
			const message =
				error && error.data && error.data.message
					? error.data.message
					: 'Enterprise billing eligibility could not be updated';
			dispatch(toastFunction('Error', message, ''));
			return false;
		}
	};
}

export const getOrgDetails = (orgId: number): AppThunk => {
	// project details
	const getConfig = { url: `organizations/${orgId}` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetOrgDetailsAction(data));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
};

// get deatils (projects and users) of each oraganization from the product owner page
export const getProdOwnerOrgDetails = (orgId: any, type: string): AppThunk => {
	const getConfig = { url: `prodOwnerOrgDetails?orgId=${orgId}&type=${type}` };

	return async (dispatch) => {
		try {
			dispatch(ClearProdOwnerOrgDetails());
			const { data = {} } = await GET(getConfig);
			console.log(data, 'DDDDDDD');
			dispatch(GetProdOwnerOrgDetails(data));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
};

export const getOrgSummaryDetails = (): AppThunk => {
	// project details
	const getConfig = { url: `organizationSummary` };
	return async (dispatch) => {
		try {
			dispatch(clearOrgSummaryDetails());
			const { data = {} } = await GET(getConfig);
			dispatch(GetOrgSummaryDetailsAction(data));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
};

export type SetupOrganizationPaymentMethod = (organizationId: number) => Promise<string>;

export function create(
	datas: any = {},
	setupPaymentMethod?: SetupOrganizationPaymentMethod,
): AppThunk<Promise<void>> {
	const postConfig = {
		data: datas,
		url: `organizations`,
	};
	return async (dispatch) => {
		try {
			const { status = 0, data = {} } = await POST(postConfig);
			const organizationId = Number(data.id);
			let completionToast: [string, string] = ['Success', 'Organization created successfully'];
			if (setupPaymentMethod) {
				if (organizationId) {
					try {
						const paymentMethodId = await setupPaymentMethod(organizationId);
						await POST({
							url: `enterprise-billings/organizations/${organizationId}/payment-method`,
							data: { paymentMethodId },
						});
					} catch (paymentError) {
						completionToast = [
							'Error',
							'Organization created, but the card could not be saved. Open Edit Organization to try again.',
						];
					}
				} else {
					completionToast = [
						'Error',
						'Organization created, but its card could not be linked. Open Edit Organization to try again.',
					];
				}
			}
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearNormalDetails());
			dispatch(clearDetails());
			dispatch(clearStatus());
			dispatch(getNormalDetails());
			dispatch(getDetails());
			dispatch(clearEnterpriseDetails());
			dispatch(getEnterpriseDetails());

			dispatch(toastFunction(completionToast[0], completionToast[1], ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 400 });
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}

export function update(
	datas: any = {},
	orgId: number,
	setupPaymentMethod?: SetupOrganizationPaymentMethod,
): AppThunk<Promise<void>> {
	const putConfig = {
		data: datas,
		url: `organizations/${orgId}`,
	};
	return async (dispatch) => {
		try {
			const { status = 0 } = await PUT(putConfig);
			let completionToast: [string, string] = ['Success', 'Organization updated successfully'];
			if (setupPaymentMethod) {
				try {
					const paymentMethodId = await setupPaymentMethod(orgId);
					await POST({
						url: `enterprise-billings/organizations/${orgId}/payment-method`,
						data: { paymentMethodId },
					});
				} catch (paymentError) {
					completionToast = [
						'Error',
						'Organization details were updated, but the card could not be saved. Please try again.',
					];
				}
			}
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearNormalDetails());
			dispatch(clearDetails());
			dispatch(clearStatus());
			dispatch(getNormalDetails());
			dispatch(getDetails());
			dispatch(clearEnterpriseDetails());
			dispatch(getEnterpriseDetails());
			dispatch(toastFunction(completionToast[0], completionToast[1], ''));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
			dispatch({ type: ActionConstant.GET_STATUS, status: 400 });
		}
	};
}
export function deleteListItem(id = 0): AppThunk {
	const deleteConfig = { url: `organizations/${id}` };
	return async function (dispatch) {
		try {
			const { status = 0 } = await DELETE(deleteConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearNormalDetails());
			dispatch(clearDetails());
			dispatch(getNormalDetails());
			dispatch(getDetails());
			dispatch(clearEnterpriseDetails());
			dispatch(getEnterpriseDetails());
			dispatch(toastFunction('Success', 'Organization deleted successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Organization deletion failed', ''));
		}
	};
}

function productOwnerReducer(state = initialState, action: ActionType): InitialState {
	switch (action.type) {
		case ActionConstant.GET_DETAILS: {
			const { count = 0, rows = [] } = action.data;
			state.list = [];
			return {
				...state,
				list: [...state.list, ...rows],
				count,
				listFetching: false,
			};
		}
		case ActionConstant.CLEAR_DETAILS: {
			return {
				...state,
				list: [],
				count: 0,
				listFetching: true,
			};
		}
		case ActionConstant.GET_NORMAL_DETAILS: {
			const { count = 0, rows = [] } = action.data;
			state.normallist = [];
			return {
				...state,
				normallist: [...state.normallist, ...rows],
				count,
				normallistFetching: false,
			};
		}
		case ActionConstant.CLEAR_NORMAL_DETAILS: {
			return {
				...state,
				list: [],
				count: 0,
				listFetching: true,
			};
		}
		case ActionConstant.GET_ENTERPRISE_DETAILS: {
			const { count = 0, rows = [] } = action.data;
			state.enterpriselist = [];
			return {
				...state,
				enterpriselist: [...state.enterpriselist, ...rows],
				count,
				enterpriselistFetching: false,
			};
		}
		case ActionConstant.GET_PROD_OWNER_ORG_DETAILS: {
			// Cast to unknown first, then to array
			const orgData = (action.data as unknown) as Array<{
				count: number;
				projects: any[];
				users: any[];
				userCount: number;
			}>;

			const orgDetails = orgData[0] || {
				count: 0,
				projects: [],
				users: [],
				userCount: 0,
			};

			return {
				...state,
				prodOwnerOrgDetails: [orgDetails],
				count: orgDetails.count,
				prodOwnerOrgDetailsFetching: false,
			};
		}

		case ActionConstant.CLEAR_PROD_OWNER_ORG_DETAILS: {
			return {
				...state,
				prodOwnerOrgDetails: [],
				count: 0,
				prodOwnerOrgDetailsFetching: true,
			};
		}
		case ActionConstant.CLEAR_ENTERPRISE_DETAILS: {
			return {
				...state,
				enterpriselist: [],
				count: 0,
				enterpriselistFetching: true,
			};
		}
		case ActionConstant.GET_ORG_DETAILS: {
			const { data } = action;
			return {
				...state,
				orgdetails: data,
				orgdetailsFetching: false,
			};
		}
		case ActionConstant.GET_ORG_SUMMARY_DETAILS: {
			const { data } = action;
			return {
				...state,
				orgsummarydetails: data,
				orgsummarydetailsFetching: false,
			};
		}
		case ActionConstant.CLEAR_ORG_DETAILS: {
			return {
				...state,
				orgdetails: {
					name: '',
					id: 0,
					primaryContact: '',
					location: '',
					phone: '',
					email: '',
				},
				orgdetailsFetching: true,
			};
		}
		case ActionConstant.CLEAR_ORG_SUMMARY_DETAILS: {
			return {
				...state,
				orgsummarydetails: {
					organizationsTotal: 0,
					paidOrganizations: 0,
					trailPlanOrganizations: 0,
					expired: 0,
					totalIndexSubscribed: 0,
					totalIndexUsed: 0,
				},
				orgsummarydetailsFetching: true,
			};
		}
		case ActionConstant.GET_STATUS: {
			return {
				...state,
				statusCode: action.status,
			};
		}
		case ActionConstant.CLEAR_STATUS: {
			return {
				...state,
				statusCode: 0,
			};
		}

		default:
			return state;
	}
}

export default productOwnerReducer;
